<template>
  <div>
    <!-- <DashboardLayout></DashboardLayout> -->
    <div class="container card" style="width: 40%;padding: 30px 20px;">
      <h2>Add User</h2>
      <form>
        <b-alert
          :show="message.length>0?true:false"
          :variant="variant"
          dismissible
          @dismissed="message=''"
        >{{message}}</b-alert>
        <div class="form-group">
          <label>Username</label>
          <input
            type="text"
            class="form-control"
            v-model="addForm.uname"
            aria-describedby="emailHelp"
            placeholder="Username"
          />
        </div>
        <div class="form-group">
          <label>Password</label>
          <input
            type="password"
            class="form-control"
            v-model="addForm.pswd"
            placeholder="Password"
            title="Password must be minimum of 8 characters, it should be alphanumeric and have at least one uppercase and one special character."
            @keyup="passwordValidation"
          />
          <small
            class="text-danger"
            v-if="!valid"
          >Password must be minimum of 8 characters, it should be alphanumeric and have at least one uppercase and one special character.</small>
        </div>
        <div class="form-group">
            <input
              id="isUserEmailAddress"
              type="checkbox"
              v-model="addForm.checked"
              style="margin-right:5px"
              class=""
            />            
            <label for="isUserEmailAddress">Add User’s Email Address</label>

          </div>
           <div class="form-group" v-if="addForm.checked">
          <label>User Email</label>
          <input
            type="email"
            class="form-control"
            v-model="addForm.uemail"
            aria-describedby="emailHelp"
            placeholder="User Email"
          />
        </div>
          
          
         
        <div class>
          <label>Plan</label>
          <el-select
            class="todo-dropdown-el-select"
            size="large"
            placeholder="Select Plan"
            v-model="addForm.plan"
          >
            <el-option
              v-for="item in plansDropdown"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="form-group">
            <label>workspace</label>
            <div class="onefrtwo">
            <div  v-for="item in workspaceTypes" v-bind:key="item.name">
                <input type="checkbox" v-model="addForm.workspaces" :id="item.name" :value="item._id">
                <label class="form-check-label" :for="item.name">{{item.name}}</label>
            </div>
            </div>
          </div>

        <!-- print result -->
        <!-- <div class="form-group">
                {{addForm}}
        </div> -->
        <div class="form-group">
          <label>Number of Months</label>
          <input
            type="number"
            class="form-control"
            v-model="addForm.numberOfMonths"
            min="1"
            step="1"
            pattern="[0-9]"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            placeholder="Number of Months"
            title="Number of months to give full access"
          />
        </div>
        <div class="form-group">
          <label>Number of Seats</label>
          <input
            type="number"
            class="form-control"
            v-model="addForm.numberOfSeats"
            min="1"
            step="1"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            placeholder="Number of Seats"
          />
        </div>
        <button
          style="margin-top: 5px;background-color:#5445F3;"
          type="button"
          :disabled="!valid"
          @click="addUser"
          class="btn btn-primary"
        >
          Submit
          <b-spinner v-if="isSubmit && valid" style="float: right;" small label="Loading..."></b-spinner>
        </button>
      </form>
      <div></div>
    </div>
  </div>
</template>
<script>
import DashboardLayout from "src/pages/Dashboard/Layout/DashboardLayout.vue";
import { mapGetters } from "vuex";
import api from "../../../axios_api";
import { Select, Option } from "element-ui";
export default {
  data() {
    return {
      addForm: {
        workspaces:[],
        uemail: ''
      },
      message: "",
      variant: "",
      isSubmit: false,
      valid: false,
      workspaceTypes:[],
      plansDropdown: [
        {
          value: "free",
          label: "Free",
        },
        {
          value: "ap",
          label: "Ap",
        },
        {
          value: "pi",
          label: "Pi",
        },
      ],
    };
  },
  components: {
    DashboardLayout,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  computed() {
    mapGetters("user", ["user"]);
  },
  methods: {
     getWorkSpaces(){
      const res=  api.get("/workspaceTypes")
      .then(res=>{
        this.workspaceTypes=res.data.encrypt.success
        console.log("get workspaces", this.workspaceTypes.data.encrypt.success)
      })
      .catch(err=>console.log(err))
    },
    addUser() {
      this.isSubmit = true;
      if (window.localStorage.getItem("email")) {
        this.addForm.email =(this.addForm.uemail && this.addForm.checked) ?this.addForm.uemail: window.localStorage.getItem("email");
        this.addForm.name = this.addForm.uname;
        this.addForm.plan =
          this.addForm.plan && this.addForm.plan.length > 0
            ? this.addForm.plan
            : "free";
        this.addForm.numberOfMonths =
          this.addForm.numberOfMonths && this.addForm.numberOfMonths.length > 0
            ? Number(this.addForm.numberOfMonths)
            : 3;
        this.addForm.numberOfSeats=this.addForm.numberOfSeats
        this.addForm.isnewUser = true;
        if(this.addForm.checked){
        api.get(`/all-customers/${this.addForm.uemail}`).then(res=>{
            if(res.data.success.data.length>0){
            api
              .post("/add-user", { encrypt: { data: this.addForm } })
              .then((resp) => {
                this.message = "User created..!!";
                this.variant = "success";
                this.addForm = {
                   workspaces:[]
                };
                this.isSubmit = false;
              })
              .catch((err) => {
                this.message = err.response.data.message;
                console.log('err is', err)
                this.variant = "danger"
                this.addForm = {}
                this.isSubmit = false;
                this.valid = false;
              });
              }else{
                this.message = "user doesn't exist in stripe";
                this.variant = "danger"
                this.isSubmit = false;
              }
          })
        }
        else{
          api
              .post("/add-user", { encrypt: { data: this.addForm } })
              .then((resp) => {
                this.message = "User created..!!"
                this.variant = "success"
                this.addForm = {
                   workspaces:[]
                };
                this.isSubmit = false;
              })
        }
      } else {
        alert("Please Login in again..!!");
        this.isSubmit = false;
        this.valid = false;
        this.$router.push("#/login");
      }
    },
    passwordValidation() {
      let data = this.checkPassword(this.addForm.pswd);
      if (data && this.addForm.uname) this.valid = true;
      else this.valid = false;
    },
    checkPassword(str) {
      var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,}$/;
      return re.test(str);
    },
  },
  mounted() {
    this.getWorkSpaces();
  },
};
</script>
<style scoped>
</style>